import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import { Button, Modal } from 'antd';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import AuthForm from '../../../components/AuthForm/AuthForm';
import AuthInfo from '../../../components/AuthInfo/AuthInfo';
import BankAccountModal from '../../../components/LinkBankAccount/BankAccountModal';

import { Lock } from '../../../assets/icons';
import { Images } from '../../../config/images';
import useGetUserProfile from '../../../Hooks/useGetUserProfile';
import { WARN_DWOLLA_PENDING } from '../../../utils/constant';
import { toastNotify } from '../../../utils/toastNotify';

import './LinkBank.scss';

const LinkBank = () => {
  const navigate = useNavigate();
  const [bankModalOpen, setBankModalOpen] = useState(false);
  const [doneModalOpen, setDoneModalOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const userProfile = useSelector((state) => state.userData.userData);

  useGetUserProfile();

  useEffect(() => {
    if (userProfile && Object.keys(userProfile).length > 0 && userProfile.isKYCVerified === false) {
      navigate('/', { replace: true });
    }
  }, [userProfile, navigate]);
  
  useEffect(() => {
    const utmSource = searchParams.get('utm_source');
    const utmMedium = searchParams.get('utm_medium');
    const utmContent = searchParams.get('utm_content');

    if (utmSource !== 'onboarding' || utmMedium !== 'web' || utmContent !== 'onboardingcompleted') {
      searchParams.set('utm_source', 'onboarding');
      searchParams.set('utm_medium', 'web');
      searchParams.set('utm_content', 'onboarding_complete');

       // Add utm_campaign from localStorage if exists (from first_touch_utm_campaign)
    if (localStorage.getItem('first_touch_utm_campaign')) {
      searchParams.set('utm_campaign', localStorage.getItem('first_touch_utm_campaign'));
    }
    
    // Add gclid from localStorage if exists (from first_touch_gclid)
    if (localStorage.getItem('first_touch_gclid')) {
      searchParams.set('gclid', localStorage.getItem('first_touch_gclid'));
    }
    
    // Add fbclid from localStorage if exists (from first_touch_fbclid)
    if (localStorage.getItem('first_touch_fbclid')) {
      searchParams.set('fbclid', localStorage.getItem('first_touch_fbclid'));
    }

    if (localStorage.getItem('first_touch_gbraid')) {
      searchParams.set('gbraid', localStorage.getItem('first_touch_gbraid'));
    }    

      setSearchParams(searchParams);
    }
  }, [setSearchParams]);

  const handleConnectBank = () => {
    if (!userProfile?.isDwollaVerified) {
      toastNotify('error', WARN_DWOLLA_PENDING);
      navigate('/', {
        replace: true,
      });
      return;
    }

    setBankModalOpen(true);
  };

  return (
    <div className='auth auth--no-info-mobile'>
      <AuthInfo
        title={<>Ready to invest, brick by brick</>}
        description={<>We use Plaid to connect to banks for easy and secure connections.</>}
        note={
          <>
            <Lock marginRight='10px' />
            <span className='fw-400'>All of your information is encrypted and secure.</span>
          </>
        }
      />
      <AuthForm title={<>Link your bank</>} description={<>Transfer funds to your Realbricks account to make your first investment.</>}>
        <>
          <div className='auth-form linkbank'>
            <div className='linkbank__item'>
              <span className='fw-700'>Instant purchase</span>
              <p>Start investing right away with easy and no-fee ACH payments via Plaid.</p>
            </div>
            <div className='linkbank__item'>
              <span className='fw-700'>Add funds</span>
              <p>You can deposit and withdraw funds from your account at any time.</p>
            </div>
            <div className='linkbank__item'>
              <span className='fw-700'>Secure integration</span>
              <p>Realbricks uses Plaid to securely transfer funds from your bank.</p>
            </div>
          </div>
          <div className='auth-form__fixed-submit multi-action'>
            <Link to='/marketplace/initial' className='fw-600 back-link'>
              I’ll do this later
            </Link>
            <Button htmlType='submit' type='primary' className='ant-btn-primary--alt' onClick={handleConnectBank}>
              Connect bank
            </Button>
          </div>
          <BankAccountModal
            bankModalOpen={bankModalOpen}
            setBankModalOpen={(value) => setBankModalOpen(value)}
            onSuccess={() => {
              setBankModalOpen(false);
              setDoneModalOpen(true);
            }}
            onClose={() => {
              setBankModalOpen(false);
            }}
          />
          <Modal open={doneModalOpen} footer={false} closable={false} header={false} onCancel={() => setDoneModalOpen(false)} width={524} centered>
            <div className='congrats'>
              <div className='mb-16 congrats__image'>
                <LazyLoadImage src={Images.allSet} alt='' />
              </div>
              <h4 className='mb-0 congrats__title'>You are all set.</h4>
              <h4 className='congrats__title'>Start investing today</h4>
              <p className='mb-48 congrats__detail'>
                You’ve officially joined Realbricks. Browse our property listings and make your first investment.{' '}
              </p>
              <div className='congrats__action'>
                <Button href='/' type='primary' className='ant-btn-primary--alt'>
                  Go to Realbricks Marketplace
                </Button>
                <a href='https://www.realbricks.com/learn' target='_blank' className='fw-600' rel='noreferrer'>
                  Learn about investing
                </a>
              </div>
            </div>
          </Modal>
        </>
      </AuthForm>
    </div>
  );
};

export default LinkBank;
